// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useCallback, useContext, useState } from 'react'
import { array, bool, func, string } from 'prop-types'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ReactGA from 'react-ga4'
import { handlePathReportsSubmit } from './helpers'
import { AuthContext } from 'components/Auth'
import { TooltipContextTrigger } from 'components/TooltipContext'

const PathReports = props => {
  const { GA_userId } = useContext(AuthContext)

  const {
    category,
    handlePathReportsSubmit,
    pathIds,
    disabledTooltip,
  } = props

  const disabled = !!disabledTooltip

  const getTooltipContent = () => (
    disabled
      ? (
        <span>
          {'Select at least one record to perform this action.'}
        </span>
      )
      : (
        <span>
          {'Renewals Data Sheets'}
        </span>
      )
  )

  const [errorMessage, setErrorMessage] = useState(null)

  const formats = ['docx']

  const handleSubmit = useCallback(async e => {
    // prevent default form submit behavior.
    e.preventDefault()

    try {
      await handlePathReportsSubmit(formats, pathIds)

      // tell GA when a data sheets export was initiated.
      ReactGA.event({
        action: 'Data sheets deliverables downloaded.',
        category: category,
        label: GA_userId,
      })
    } catch (err) {
      console.warn(err)
      setErrorMessage(() => err.message || 'Uncaught Error')
    }
  // track all these things in this callback so we can use <PathReports />
  // as generically as possible.
  }, [formats, handlePathReportsSubmit, pathIds])

  return (
    <>
      { errorMessage &&
        <p className={'error-message'}>
          {errorMessage}
        </p>
      }

      <TooltipContextTrigger
        getTooltipContent={getTooltipContent}
        id={'pcn-renewals-data-sheets'} >
        <Button
          color={'primary'}
          className={`margin-left-1 ${disabled ? 'disabled pointer-events-none' : 'cursor-pointer'}`}
          onClick={handleSubmit}>
          {'Datasheets'}
        </Button>
      </TooltipContextTrigger>
    </>
  )
}

PathReports.propTypes = {
  category: string.isRequired,
  disabledTooltip: bool.isRequired,
  handlePathReportsSubmit: func.isRequired,
  pathIds: array.isRequired,
  highlightedPathIds: array.isRequired,
}

const mapStateToProps = ({ projectTracker }) => {
  const { highlightedPathIds } = projectTracker.pcnRenewal

  const disabledTooltip = (
    !highlightedPathIds.length
  )

  return {
    highlightedPathIds,
    disabledTooltip,
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    handlePathReportsSubmit,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PathReports)
